var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "c-buffer-box c-buffer-box--vertical c-buffer-box--super-tight-top-ends t-border-green"
    },
    [
      _c(
        "form",
        {
          staticClass: "c-form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.handleSubmit($event)
            }
          }
        },
        [
          _c("fieldset", [
            _c("div", { staticClass: "o-grid" }, [
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-s",
                  attrs: { "data-size": "sm:10 md:10 lg:10" }
                },
                [
                  _c(
                    "fieldset",
                    { ref: "courseType", staticClass: "c-radio-group" },
                    [
                      _c("div", { staticClass: "c-radio c-radio--inline" }, [
                        _c("input", {
                          staticClass: "c-radio__input",
                          attrs: {
                            type: "radio",
                            name: "type",
                            value: "Course",
                            id: _vm.courseRadioId
                          },
                          domProps: {
                            checked: _vm.courseType !== "Certification"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "c-radio__label",
                            attrs: { for: _vm.courseRadioId }
                          },
                          [_vm._v("Kurs")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-radio c-radio--inline" }, [
                        _c("input", {
                          staticClass: "c-radio__input",
                          attrs: {
                            type: "radio",
                            name: "type",
                            value: "Certification",
                            id: _vm.certificationRadioId
                          },
                          domProps: {
                            checked: _vm.courseType === "Certification"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "c-radio__label",
                            attrs: { for: _vm.certificationRadioId }
                          },
                          [_vm._v("Intyg/certifikat")]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "[ o-grid__column o-grid__column--align-center ] t-margin-bottom-s",
                  attrs: { "data-size": "sm:2 md:2 lg:2" }
                },
                [
                  _c("div", { staticClass: "t-text-align-right" }, [
                    _vm.status === "Expired"
                      ? _c(
                          "div",
                          {
                            staticClass: "c-notify-pill",
                            attrs: { title: "Löpt ut" }
                          },
                          [_c("span", [_vm._v("Löpt ut")])]
                        )
                      : _vm.status === "Expiring"
                      ? _c(
                          "div",
                          {
                            staticClass: "c-notify-pill",
                            attrs: { title: "Löper snart ut" }
                          },
                          [_c("span", [_vm._v("Löper snart ut")])]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-s",
                  attrs: { "data-size": "sm:12 md:4 lg:4" }
                },
                [
                  _c("dropdown-variations", {
                    ref: "category",
                    attrs: {
                      "item-groups": _vm.courseOptions,
                      label: "Välj kurskategori",
                      value: _vm.category,
                      "allow-custom-value": true,
                      filterable: true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-xs",
                  attrs: { "data-size": "sm:12 md:8 lg:8" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-form__item" },
                    [
                      _c("vue-input", {
                        ref: "name",
                        attrs: {
                          label: "Namn på kurs/certifiering",
                          "input-id": "name-" + _vm.id,
                          value: _vm.name
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-xs",
                  attrs: { "data-size": "sm:12 md:6 lg:6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-form__item" },
                    [
                      _c("vue-input", {
                        ref: "issuer",
                        attrs: {
                          label: "Utfärdare/Arrangör",
                          "input-id": "issuer-" + _vm.id,
                          value: _vm.issuer
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-xs",
                  attrs: { "data-size": "sm:12 md:6 lg:6" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-form__item" },
                    [
                      _c("date-input", {
                        ref: "issued",
                        attrs: {
                          label: "Kurs-/utfärdandedatum (åååå-mm-dd)",
                          "input-id": "issued-" + _vm.id,
                          value: _vm.issued
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-xs",
                  attrs: { "data-size": "sm:12 md:7 lg:7" }
                },
                [
                  _c("div", { staticClass: "c-form__item" }, [
                    _c(
                      "fieldset",
                      { ref: "validTo", staticClass: "c-radio-group" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "o-grid o-grid--align-center  c-coworker-course__radiogroup"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-radio t-margin-right-s" },
                              [
                                _c("input", {
                                  staticClass: "c-radio__input",
                                  attrs: {
                                    type: "radio",
                                    name: "validyToDate",
                                    id: "permanent-" + this.id,
                                    value: "UntilFurtherNotice"
                                  },
                                  domProps: {
                                    checked:
                                      !_vm.expires ||
                                      (_vm.validTo &&
                                        _vm.validTo.type &&
                                        _vm.validTo.type ===
                                          "UntilFurtherNotice")
                                  },
                                  on: { change: _vm.shouldInputBeEnabled }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "c-radio__label",
                                    attrs: { for: "permanent-" + this.id }
                                  },
                                  [_vm._v("Giltig tills vidare")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "c-radio t-margin-right-s" },
                              [
                                _c("input", {
                                  staticClass: "c-radio__input",
                                  attrs: {
                                    type: "radio",
                                    name: "validyToDate",
                                    value: "ExpiresAt",
                                    id: "date-" + this.id
                                  },
                                  domProps: {
                                    checked:
                                      _vm.expires ||
                                      (_vm.validTo &&
                                        _vm.validTo.type &&
                                        _vm.validTo.type === "ExpiresAt")
                                  },
                                  on: { change: _vm.shouldInputBeEnabled }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "c-radio__label",
                                    attrs: { for: "date-" + this.id }
                                  },
                                  [_vm._v("Giltig till datum")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("date-input", {
                              ref: "date",
                              attrs: {
                                label: "Datum (åååå-mm-dd)",
                                required: _vm.enableInput,
                                disabled: !_vm.enableInput,
                                "input-id": "date-" + _vm.id,
                                value: _vm.expires
                                  ? _vm.formatDate(_vm.expires)
                                  : ""
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column t-margin-bottom-xs",
                  attrs: { "data-size": "sm:12 md:5 lg:5" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "c-form__item" },
                    [
                      _c("vue-input", {
                        ref: "certificationLink",
                        attrs: {
                          label: "Länk till kursbevis",
                          required: false,
                          "input-id": "certificationLink-" + _vm.id,
                          value: _vm.certificationLink
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.displayHandleExpiration
                ? _c(
                    "div",
                    {
                      staticClass: "o-grid__column",
                      attrs: { "data-size": "sm:12 md:12 lg:12" }
                    },
                    [
                      _c("vue-input", {
                        ref: "expirationHandleMode",
                        attrs: {
                          type: "checkbox",
                          label: "Giltighet/utgång hanterad",
                          inputId: "expirationHandleMode-" + _vm.courseId,
                          checked:
                            _vm.expirationHandleMode === "Handled"
                              ? "checked"
                              : null
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "o-grid__column",
                  attrs: { "data-size": "sm:12 md:12 lg:12" }
                },
                [
                  _c("vue-input", {
                    ref: "printOption",
                    attrs: {
                      type: "checkbox",
                      label: "Visa på kompetenskort",
                      inputId: "printOption-" + _vm.courseId,
                      checked: _vm.printOption === "Display" ? "checked" : null
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "o-grid" },
              [
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "t-margin-bottom-xs t-margin-top-m t-text-align-left"
                      },
                      [
                        _vm.mode === "edit"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset",
                                attrs: { type: "submit" },
                                on: { click: _vm.toggleDeleteModal }
                              },
                              [_vm._v("Ta bort kurs/intyg")]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "modal",
                  {
                    attrs: { show: _vm.showDeleteModal },
                    on: { closeModal: _vm.toggleDeleteModal }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-modal__content t-background-white t-text-align-center"
                      },
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "t-text-style-alpha t-margin-bottom-s"
                          },
                          [
                            _vm._v(
                              'Du tar nu bort kursen/intyget "' +
                                _vm._s(_vm.name) +
                                '"'
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "c-form",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.handleSubmit($event)
                              }
                            }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                                on: { click: _vm.toggleDeleteModal }
                              },
                              [_vm._v("Avbryt")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--primary t-margin-top-m",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.setSubmitType("delete")
                                  }
                                }
                              },
                              [_vm._v("Ta bort")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:6" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "t-margin-bottom-xs t-margin-top-s t-text-align-right"
                      },
                      [
                        _vm.mode === "create"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.cancelAddCourse($event)
                                  }
                                }
                              },
                              [_vm._v("Avbryt")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode === "create"
                          ? _c(
                              "button",
                              {
                                staticClass: "c-button c-button--primary",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.setSubmitType("create")
                                  }
                                }
                              },
                              [_vm._v("Spara")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode === "edit"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.cancelEditCourse($event)
                                  }
                                }
                              },
                              [_vm._v("Avbryt")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode === "edit"
                          ? _c(
                              "button",
                              {
                                staticClass: "c-button c-button--primary",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.setSubmitType("edit")
                                  }
                                }
                              },
                              [_vm._v("Spara")]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }